// import * as React from "react";
// import {
//     Box,
//     IconButton,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Button,
//     TextField,
//     Tooltip,
//     Snackbar,
//     Alert,
// } from "@mui/material";
// import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
// import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";

// export const Feedback = () => {
//     const [vote, setVote] = React.useState(null); // "up" | "down" | null
//     const [open, setOpen] = React.useState(false);
//     const [feedback, setFeedback] = React.useState("");
//     const [submitting, setSubmitting] = React.useState(false);
//     const [snackbarOpen, setSnackbarOpen] = React.useState(false);

//     const handleUp = () => {
//         setVote("up");
//         //  onVote?.("up");
//         setOpen(false);
//     };

//     const handleDown = () => {
//         setVote("down");
//         //   onVote?.("down");
//         setOpen(true);
//     };

//     const handleClose = () => {
//         setOpen(false);
//         setFeedback("");
//     };

//     const handleSubmit = async () => {
//         const text = feedback.trim();
//         if (!text) return;

//         try {
//             setSubmitting(true);
//             //  await onSubmitFeedback?.({ feedback: text });
//             handleClose();
//             setSnackbarOpen(true);
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     return (
//         <>
//             <Box sx={{ display: "flex", gap: 1, alignItems: "center", marginLeft: "auto", mt: 1 }}>
//                 <Tooltip title="Good Response">
//                     <IconButton
//                         onClick={handleUp}
//                         aria-label="Thumbs up"
//                         sx={{
//                             border: "2px solid",
//                             borderColor: vote === "up" ? "success.main" : "divider",
//                             bgcolor: "background.paper",
//                         }}
//                     >
//                         <ThumbUpAltOutlinedIcon
//                             sx={{ color: "success.main", fontSize: 20 }}
//                         />
//                     </IconButton>
//                 </Tooltip>

//                 <Tooltip title="Bad Response">
//                     <IconButton
//                         onClick={handleDown}
//                         aria-label="Thumbs down"
//                         sx={{
//                             border: "2px solid",
//                             borderColor: vote === "down" ? "error.main" : "divider",
//                             bgcolor: "background.paper",
//                         }}
//                     >
//                         <ThumbDownAltOutlinedIcon
//                             sx={{ color: "error.main", fontSize: 20 }}
//                         />
//                     </IconButton>
//                 </Tooltip>
//             </Box>

//             <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
//                 <DialogTitle>Share feedback</DialogTitle>

//                 <DialogContent>
//                     <TextField
//                         autoFocus
//                         placeholder="Enter your feedback..."
//                         fullWidth
//                         multiline
//                         minRows={4}
//                         value={feedback}
//                         onChange={(e) => setFeedback(e.target.value)}
//                     />
//                 </DialogContent>

//                 <DialogActions sx={{ px: 3, pb: 2 }}>
//                     <Button onClick={handleClose} disabled={submitting}>
//                         Cancel
//                     </Button>
//                     <Button
//                         variant="contained"
//                         onClick={handleSubmit}
//                     >
//                         Submit
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//             {/* Bottom-center success alert */}
//             <Snackbar
//                 open={snackbarOpen}
//                 autoHideDuration={3000}
//                 onClose={() => setSnackbarOpen(false)}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//             >
//                 <Alert
//                     onClose={() => setSnackbarOpen(false)}
//                     severity="success"
//                     variant="filled"
//                     sx={{ width: "100%" }}
//                 >
//                     Feedback submitted successfully
//                 </Alert>
//             </Snackbar>
//         </>
//     );
// }

import * as React from "react";
import {
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Tooltip,
  Snackbar,
  Alert,
} from "@mui/material";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import { getSession } from "../Utils/Sessions";

/**
 * Feedback (Thumb-down only triggers API)
 *
 * Props:
 *  - rfpFile: File (required for API payload)
 *  - field_path: string (required; must match allowed field paths)
 *  - BASE_URL: string (required; same as analyzeDocument)
 *
 * API:
 *  POST `${BASE_URL}pfg-bp-rfp-intake`
 *  Payload:
 *   {
 *     file_name,
 *     file_b64,
 *     session_id,
 *     router: "feedback",
 *     field_path,
 *     rating: "down",
 *     feedback
 *   }
 */

export const Feedback = ({ rfpFile, field_path, BASE_URL }) => {
  const sessionId = getSession();

  const [vote, setVote] = React.useState(null); // "up" | "down" | null
  const [open, setOpen] = React.useState(false);
  const [feedback, setFeedback] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarType, setSnackbarType] = React.useState("success");
  const [snackbarMsg, setSnackbarMsg] = React.useState("Feedback submitted");

  const [fileB64, setFileB64] = React.useState(null);
  const [fileName, setFileName] = React.useState(null);

  const showSnack = (type, msg) => {
    setSnackbarType(type);
    setSnackbarMsg(msg);
    setSnackbarOpen(true);
  };

  // Convert file to base64 ONCE whenever rfpFile changes
  React.useEffect(() => {
    let cancelled = false;

    async function toB64(file) {
      if (!file) {
        setFileB64(null);
        setFileName(null);
        return;
      }
      setFileName(file.name);

      const reader = new FileReader();
      reader.onload = () => {
        if (cancelled) return;
        const dataUrl = reader.result; // data:<mime>;base64,...
        const b64 = String(dataUrl).split(",")[1];
        setFileB64(b64 || null);
      };
      reader.onerror = () => {
        if (cancelled) return;
        setFileB64(null);
      };
      reader.readAsDataURL(file);
    }

    toB64(rfpFile);

    return () => {
      cancelled = true;
    };
  }, [rfpFile]);

  const postThumbDownFeedback = async (comment) => {
    if (!BASE_URL) {
      throw new Error("BASE_URL not provided to Feedback component");
    }
    if (!rfpFile || !fileB64 || !fileName) {
      throw new Error("RFP file not available for feedback payload");
    }
    if (!sessionId) {
      throw new Error("sessionId not available");
    }
    if (!field_path) {
      throw new Error("field_path not provided");
    }

    const payload = {
      file_name: fileName,
      file_b64: fileB64,
      session_id: sessionId,
      router: "feedback",
      field_path,
      rating: vote,
      feedback: comment,
    };

    const res = await fetch(`${BASE_URL}pfg-bp-rfp-intake`, {
      method: "POST",
      headers: { "Content-Type": "application/json","x-file-name":fileName },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Feedback API failed (${res.status}). ${text}`);
    }
  };

  // ✅ Thumb up: NO API call
  const handleUp = () => {
    setVote("up");
    setOpen(true);
    //showSnack("success", "Thanks!");
  };

  const handleDown = () => {
    setVote("down");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFeedback("");
  };

  // ✅ Thumb down: API call happens here
  const handleSubmit = async () => {
    const text = feedback.trim();
    if (vote === "down" && !text) {
      showSnack("warning", "Please enter feedback before submitting.");
      return;
    }

    try {
      setSubmitting(true);
      await postThumbDownFeedback(text);
      handleClose();
      showSnack("success", "Feedback submitted successfully");
    } catch (e) {
      console.error(e);
      showSnack(
        "error",
        "Could not submit feedback. Please check file/session and try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          marginLeft: "auto",
          mt: 1,
        }}
      >
        <Tooltip title="Good Response">
          <span>
            <IconButton
              onClick={handleUp}
              aria-label="Thumbs up"
              sx={{
                border: "2px solid",
                borderColor: vote === "up" ? "success.main" : "divider",
                bgcolor: "background.paper",
              }}
            >
              <ThumbUpAltOutlinedIcon
                sx={{ color: "success.main", fontSize: 20 }}
              />
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip title="Bad Response (sends feedback)">
          <span>
            <IconButton
              onClick={handleDown}
              aria-label="Thumbs down"
              sx={{
                border: "2px solid",
                borderColor: vote === "down" ? "error.main" : "divider",
                bgcolor: "background.paper",
              }}
            >
              <ThumbDownAltOutlinedIcon
                sx={{ color: "error.main", fontSize: 20 }}
              />
            </IconButton>
          </span>
        </Tooltip>
      </Box>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Share feedback</DialogTitle>

        <DialogContent>
          <TextField
            autoFocus
            placeholder="Enter your feedback..."
            fullWidth
            multiline
            minRows={4}
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            disabled={submitting}
          />
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose} disabled={submitting}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={submitting}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </>
  );
};
